var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditEmailWin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7656",
    d: "M2.713 13.129H.868v-1.907L8.3 3.76l-.6-.6L0 10.895V14h3.093l7.705-7.79-.6-.545z",
    fill: "#8a8886"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7657",
    d: "M13.566 1.362l-.977-.926A1.61 1.61 0 0011.504 0a1.348 1.348 0 00-1.031.381L8.248 2.615l3.147 3.051 2.171-2.179A1.29 1.29 0 0014 2.452a1.734 1.734 0 00-.434-1.09z",
    fill: "#8a8886"
  })));
}
export default SvgEditEmailWin;